/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_German_Level_TitleInputs */

const en_reset_german_level_title = /** @type {(inputs: Reset_German_Level_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset German level`)
};

const de_reset_german_level_title = /** @type {(inputs: Reset_German_Level_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutschkenntnisse zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset German level" |
*
* @param {Reset_German_Level_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const reset_german_level_title = /** @type {((inputs?: Reset_German_Level_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_German_Level_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_reset_german_level_title(inputs)
	return en_reset_german_level_title(inputs)
});